module.exports = __webpack_public_path__ + "img/sortons jouer 2024.515b40f2.webp";